import { BASE_API_URL } from "@/constants";
import fpFetch from "@/services/fpFetch";
import { v4 as uuidv4 } from "uuid";

const reprocessFile = async (fileId: string) => {
  const response = await fpFetch(`${BASE_API_URL}/userData/fp0062ar`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      fileId,
    }),
  });

  if (!response?.ok) {
    throw new Error("Network response was not ok " + response.statusText);
  }
};

export default reprocessFile;
